import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Loader from './components/Loader';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Services from './components/sections/Services';
import Team from './components/sections/Team';
import Products from './components/sections/Products';
import Contact from './components/sections/Contact';
import HelpCenter from './components/sections/HelpCenter';
import MediaGallery from './components/sections/MediaGallery';
import PrivacyPolicy from './components/sections/PrivacyPolicy';
import TermsAndConditions from './components/sections/TermsAndConditions';
import ScrollToTop from './components/ScrollToTop';

import './styles/reset.css';
import './styles/variables.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/loader.css';
import './styles/sections/hero.css';
import './styles/sections/about.css';
import './styles/sections/services.css';
import './styles/sections/team.css';
import './styles/sections/products.css';
import './styles/sections/contact.css';
import './styles/sections/helpcenter.css';
import './styles/sections/mediagallery.css';
import './styles/sections/privacy-policy.css';
import './styles/popupstyles/heropopup.css';

function App() {
  // Check if loader has already been shown in this session
  const [isLoading, setIsLoading] = useState(() => {
    const hasSeenLoader = sessionStorage.getItem('loaderShown');
    return !hasSeenLoader; // Show loader only if not seen before
  });

  const handleLoadComplete = () => {
    setIsLoading(false);
    // Mark loader as shown for this session
    sessionStorage.setItem('loaderShown', 'true');
  };

  return (
    <>
      {isLoading && <Loader onLoadComplete={handleLoadComplete} />}
      <Router>
        <ScrollToTop />
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/"             element={<Hero />} />
              <Route path="/about"        element={<About />} />
              <Route path="/services"     element={<Services />} />
              <Route path="/team"         element={<Team />} />
              <Route path="/products"     element={<Products />} />
              <Route path="/contact"      element={<Contact />} />
              <Route path="/help"         element={<HelpCenter />} />
              <Route path="/media-gallery" element={<MediaGallery />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;